import { Component, OnInit, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { AxGridComponent } from 'src/app/shared/components';
import { SummaryService } from '../../summary/summary.service';
import { FactorService } from '../factor.service';
import { NGXLogger } from 'ngx-logger';
import { HistoryTabService } from '../history-tab/history-tab.service';

@Component({
  selector: 'app-factor-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss']
})
export class SecurityComponent implements AfterViewInit {
  @ViewChild(AxGridComponent) grid!: AxGridComponent;

  @Output() onClick = new EventEmitter();
  @Output() onLoad = new EventEmitter();

  private seriesName!: string;
  private category!: string;
  private currency!: string;
  private name!: string;

  constructor(
    public summary: SummaryService,
    private factor: FactorService,
    private history: HistoryTabService,
    private logger: NGXLogger
  ) { }

  ngAfterViewInit() {
    this.factor.retrieveSecurityColumns().subscribe(
      data => {
        let jsonObj = JSON.parse(data);
        this.grid.setColumns(jsonObj);
      });
  }

  cellButtonClickHandler(evt:any) {
    let secId = evt.element.innerText;
    this.grid.dataSource.forEach(data => {
      if (data.security_id == secId) {
        this.onClick.emit({ security_id: secId, axsid: data.axsid });
        return;
      }
    })
  }

  cellDragHandler(evt:any) {
    let cellInfoStr = evt.dataTransfer.getData('text');
    let cellInfoObj = JSON.parse(cellInfoStr);
    let col = this.grid.columns[cellInfoObj.columnIndex];
    let tabObj = this.history.createSecurityHistoryTab(this.summary.reportId, this.seriesName, this.category, this.currency, this.name, cellInfoObj.rowData.security_id, cellInfoObj.rowData.axsid, col.dataField, col.caption);
    let tabStr = '';
    if (tabObj) {
      tabStr = JSON.stringify(tabObj);
    }

    evt.dataTransfer.setData("text", tabStr);
  }

  public retrieve(seriesName: string, category: string, currency: string, name: string) {
    this.seriesName = seriesName;
    this.category = category;
    this.currency = currency;
    this.name = name;

    this.logger.debug("GFPA Factor retrieveSecurity started");
    this.grid.showLoadingIndicator();
    this.onLoad.emit();
    this.factor.retrieveSecurity(seriesName, category, currency, name).subscribe(
      data => {
        let jsonObj = JSON.parse(data);
        this.grid.dataSource = jsonObj;
        this.logger.debug("GFPA Factor retrieveSecurity finished");
      })
      .add(() => {
        this.grid.hideLoadingIndicator();
      });
  }
}
